/**
 * Treatment-status bands for the Diagnosis section. Only two states per the
 * user's finalised design: Ongoing (active treatment) and Resolved (cleared).
 * Colours mirror the CC v2 VAS "mild" (green) and "absent/resolved" (grey)
 * palettes so the two sections share a visual grammar.
 *
 * The `on-hold` / `none` states from the original scaffold were removed —
 * they never made it into the locked spec and the backend only stores an
 * `ongoing bool`.
 */
export const TREATMENT_STATUS = [
  // Ongoing rides the AMBER chip on the Diagnosis board (3272:2702).
  { key: "ongoing", label: "Ongoing", dot: "#f97f0f", bg: "#fdead7", fg: "#f97f0f" },
  /* Resolved is GREEN on the board — the "DA / Dropdown chip · better" layer:
     fill rgba(167,243,208,.55), and the dot, label and chevron all #065F46.
     It had been grey, which read as "no status" rather than "cleared" and made
     a resolved complaint indistinguishable from an unset one at a glance. */
  { key: "resolved", label: "Resolved", dot: "#065F46", bg: "rgba(167, 243, 208, 0.55)", fg: "#065F46" },
];

// Backend stores `ongoing bool`; the UI uses the string key. These helpers
// keep the mapping in one place.
export const statusKeyFromOngoing = (ongoing) => (ongoing ? "ongoing" : "resolved");
export const ongoingFromStatusKey = (key) => key === "ongoing";

export const treatmentBand = (key) =>
  TREATMENT_STATUS.find((t) => t.key === key) || TREATMENT_STATUS[0];
